import { defineMessages } from 'react-intl';

export const statusMessages = defineMessages({
  intransit: {
    defaultMessage: 'In Transit',
    id: 'IueMYW',
    description: 'Human readable status for In Transit Advance Shipping Notice status',
  },
  received: {
    defaultMessage: 'Received',
    id: 'ZQSlj5',
    description: 'Human readable status for Received Advance Shipping Notice status',
  },
  incomplete: {
    defaultMessage: 'Incomplete',
    id: '1TC3Y2',
    description: 'Human readable status for Incomplete Advance Shipping Notice status',
  },
  awaiting: {
    defaultMessage: 'Awaiting',
    id: 'BMolNk',
    description: 'Human readable status for Awaiting Advance Shipping Notice status',
  },
  processing: {
    defaultMessage: 'Processing',
    id: 'W/y7vH',
    description: 'Human readable status for Processing Advance Shipping Notice status',
  },
  arrived: {
    defaultMessage: 'Arrived',
    id: 'UIPkGG',
    description: 'Human readable status for Arrived Advance Shipping Notice status',
  },
  partiallyarrived: {
    defaultMessage: 'Partially Arrived',
    id: 'lfPWqw',
    description: 'Human readable status for Partially Arrived Advance Shipping Notice status',
  },
  partiallyarrivedathub: {
    defaultMessage: 'Partially Arrived at Hub',
    id: 'cI4vy2',
    description: 'Human readable status for Partially Arrived at Hub Advance Shipping Notice status',
  },
  arrivedathub: {
    defaultMessage: 'Arrived at Hub',
    id: 'WJC3RM',
    description: 'Human readable status for Arrived at Hub Advance Shipping Notice status',
  },
  processingathub: {
    defaultMessage: 'Processing at Hub',
    id: 'IcluDj',
    description: 'Human readable status for Processing at Hub Advance Shipping Notice status',
  },
  internaltransfer: {
    defaultMessage: 'Internal Transfer',
    id: 'gyzvon',
    description: 'Human readable status for Internal Transfer Advance Shipping Notice status',
  },
  cancelled: {
    defaultMessage: 'Cancelled',
    id: 'M5y0rT',
    description: 'Human readable status for Cancelled Advance Shipping Notice status',
  },
  completed: {
    defaultMessage: 'Completed',
    id: 'jeYin7',
    description: 'Human readable status for Completed Advance Shipping Notice status',
  },
  draft: {
    defaultMessage: 'Draft',
    id: 'lw51Fp',
    description: 'Human readable status for Draft Advance Shipping Notice status',
  },
});
